// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ccb-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;
}

.ccb-column {
  flex-direction: column;
  gap: 10px;
}

.ccb-option {
  display: inline-flex;
  align-items: flex-start;
  gap: 9px;
  margin: 0;
  color: var(--cui-text);
  font-size: var(--cui-font-size);
  line-height: 1.4;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.ccb-disabled {
  color: var(--cui-text-placeholder);
  cursor: not-allowed;
}

/* Real input is hidden but stays focusable for keyboard users */
.ccb-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.ccb-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-top: 1px;
  border: var(--cui-border-width) solid var(--cui-border);
  border-radius: 5px;
  background: var(--cui-bg);
  transition: background var(--cui-transition), border-color var(--cui-transition),
    box-shadow var(--cui-transition);
}

.ccb-option:hover:not(.ccb-disabled) .ccb-box {
  border-color: var(--cui-primary);
}

.ccb-input:focus-visible + .ccb-box {
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

.ccb-tick {
  width: 12px;
  height: 12px;
  fill: none;
  stroke: var(--cui-text-on-primary);
  stroke-width: 2.2;
  stroke-linecap: round;
  stroke-linejoin: round;
  opacity: 0;
  transform: scale(0.6);
  transition: opacity var(--cui-transition), transform var(--cui-transition);
}

.ccb-input:checked + .ccb-box,
.ccb-input:indeterminate + .ccb-box {
  border-color: var(--cui-primary);
  background: var(--cui-primary);
}

.ccb-input:checked + .ccb-box .ccb-tick,
.ccb-input:indeterminate + .ccb-box .ccb-tick {
  opacity: 1;
  transform: scale(1);
}

.ccb-disabled .ccb-box {
  border-color: var(--cui-border);
  background: var(--cui-bg-disabled);
}

.ccb-disabled .ccb-input:checked + .ccb-box {
  border-color: var(--cui-text-placeholder);
  background: var(--cui-text-placeholder);
}

/* Error: red box border */
.ccb-error .ccb-box,
.ccb-error:hover .ccb-box {
  border-color: var(--cui-danger);
}

.ccb-error .ccb-input:focus-visible + .ccb-box {
  box-shadow: 0 0 0 3px var(--cui-danger-ring);
}

.ccb-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.ccb-required {
  margin-left: 3px;
  color: var(--cui-danger);
}

.ccb-desc {
  color: var(--cui-text-muted);
  font-size: var(--cui-font-size-sm);
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomCheckbox/CustomCheckbox.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,uDAAuD;EACvD,kBAAkB;EAClB,yBAAyB;EACzB;oCACkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,qBAAqB;EACrB,0EAA0E;AAC5E;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA,0BAA0B;AAC1B;;EAEE,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;AACpC","sourcesContent":[".ccb-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 18px;\n}\n\n.ccb-column {\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ccb-option {\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 9px;\n  margin: 0;\n  color: var(--cui-text);\n  font-size: var(--cui-font-size);\n  line-height: 1.4;\n  cursor: pointer;\n  user-select: none;\n}\n\n.ccb-disabled {\n  color: var(--cui-text-placeholder);\n  cursor: not-allowed;\n}\n\n/* Real input is hidden but stays focusable for keyboard users */\n.ccb-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.ccb-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  margin-top: 1px;\n  border: var(--cui-border-width) solid var(--cui-border);\n  border-radius: 5px;\n  background: var(--cui-bg);\n  transition: background var(--cui-transition), border-color var(--cui-transition),\n    box-shadow var(--cui-transition);\n}\n\n.ccb-option:hover:not(.ccb-disabled) .ccb-box {\n  border-color: var(--cui-primary);\n}\n\n.ccb-input:focus-visible + .ccb-box {\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n.ccb-tick {\n  width: 12px;\n  height: 12px;\n  fill: none;\n  stroke: var(--cui-text-on-primary);\n  stroke-width: 2.2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  opacity: 0;\n  transform: scale(0.6);\n  transition: opacity var(--cui-transition), transform var(--cui-transition);\n}\n\n.ccb-input:checked + .ccb-box,\n.ccb-input:indeterminate + .ccb-box {\n  border-color: var(--cui-primary);\n  background: var(--cui-primary);\n}\n\n.ccb-input:checked + .ccb-box .ccb-tick,\n.ccb-input:indeterminate + .ccb-box .ccb-tick {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.ccb-disabled .ccb-box {\n  border-color: var(--cui-border);\n  background: var(--cui-bg-disabled);\n}\n\n.ccb-disabled .ccb-input:checked + .ccb-box {\n  border-color: var(--cui-text-placeholder);\n  background: var(--cui-text-placeholder);\n}\n\n/* Error: red box border */\n.ccb-error .ccb-box,\n.ccb-error:hover .ccb-box {\n  border-color: var(--cui-danger);\n}\n\n.ccb-error .ccb-input:focus-visible + .ccb-box {\n  box-shadow: 0 0 0 3px var(--cui-danger-ring);\n}\n\n.ccb-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.ccb-required {\n  margin-left: 3px;\n  color: var(--cui-danger);\n}\n\n.ccb-desc {\n  color: var(--cui-text-muted);\n  font-size: var(--cui-font-size-sm);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
